import { useState } from "react";
import { CheckboxProps, Col, Flex, Form, Tooltip, Typography } from "antd";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { CustomButton, DefaultCheckbox, ExpTimeInput } from "ui";
import { useNotificationContext } from "providers";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { convertFromISOHourMinuteDuration, convertToISODuration, parseErrorMessage } from "utils";
import { NormalizedError, updateDefaultQuoteExpTime } from "services";

interface IProps {
  currentValue: string;
}

export const EditQuoteExpTimeModal = observer((props: IProps) => {
  const { actionModals, user, profile } = useStores();
  const { openNotification } = useNotificationContext();

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const companyId = user.userInfo?.company_id;
  const currentDuration = convertFromISOHourMinuteDuration(props.currentValue);

  const [expTimeFrame, setExpTimeFrame] = useState(currentDuration[0] === 0 && currentDuration[1] === 0);

  const handleChangeFrame: CheckboxProps["onChange"] = (e) => {
    setExpTimeFrame(e.target.checked);
    if (e.target.checked) {
      form.setFieldValue("minutes", "");

      form.setFieldValue("hours", "");
    }
  };

  const handleEditQuoteExpTime = async (values: { hours: number; minutes: number }) => {
    if (companyId) {
      setLoading(true);
      const sendData =
        +values.hours || +values.minutes ? convertToISODuration(values.hours, values.minutes) : undefined;
      await updateDefaultQuoteExpTime({ defaultQuoteExpDuration: sendData })
        .then(() => {
          openNotification({
            message: "Срок действия котировки успешно отредактирован",
            type: NOTIFICATION_TYPE_ENUM.SUCCESS,
          });
          setTimeout(() => profile.fetchProfileById(user.userInfo!.id, companyId), 1500);
          actionModals.closeAll();
        })
        .catch((e: NormalizedError) => {
          openNotification({
            description: parseErrorMessage(e),
            type: NOTIFICATION_TYPE_ENUM.ERROR,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      openNotification({
        description: "Произошла ошибка при определении компании пользователя",
        type: NOTIFICATION_TYPE_ENUM.ERROR,
      });
    }
  };

  const handleCloseModal = () => {
    actionModals.closeAll();
  };

  return (
    <Form
      form={form}
      name="EditExpTime"
      onFinish={handleEditQuoteExpTime}
      initialValues={{
        hours: currentDuration[0].toString(),
        minutes: currentDuration[1].toString(),
      }}
    >
      <Flex vertical gap="middle">
        <Flex vertical>
          <Typography.Text strong className="margin-bottom-xs margin-top-xs">
            Срок действия котировок
          </Typography.Text>
          <ExpTimeInput disabled={loading || expTimeFrame} />
          <Flex>
            <Tooltip title="Котировка не ограничена во времени">
              <DefaultCheckbox onChange={handleChangeFrame} defaultChecked={expTimeFrame}>
                Бессрочная
              </DefaultCheckbox>
            </Tooltip>
          </Flex>
        </Flex>
        <Form.Item>
          <Flex gap="large">
            <Col>
              <CustomButton htmlType="submit" loading={loading} disabled={loading}>
                Сохранить
              </CustomButton>
            </Col>
            <Col>
              <CustomButton variant="outlined" loading={loading} disabled={loading} onClick={handleCloseModal}>
                Отмена
              </CustomButton>
            </Col>
          </Flex>
        </Form.Item>
      </Flex>
    </Form>
  );
});
